import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — floating wall shelves authored at their true mounting height
// (boards at y = 1.2 and y = 1.7, no floor contact). The wall plane is the
// tile centre (z = 0); the boards project toward +Z, like the wall pieces.
const OAK = "#c8975a";
const BLACK = "#2e2e30";
const BOOK_BRICK = "#a05a40";
const BOOK_BLUE = "#8a9aa8";
const BOOK_GREEN = "#6f7d68";

export const wallShelf = defineModel({
  id: "wall-shelf",
  batchId: "modern",
  name: "Wall shelf",
  tags: ["modern", "interior", "furniture", "storage", "wall-mounted", "living-room"],
  summary: "Two floating oak wall shelves with a few books.",
  tiles: { w: 1, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      // oak boards
      { geometry: new THREE.BoxGeometry(0.9, 0.04, 0.22), color: OAK, position: [0, 1.2, 0.11] },
      { geometry: new THREE.BoxGeometry(0.9, 0.04, 0.22), color: OAK, position: [0, 1.7, 0.11] },
      // matte-black brackets under each board
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.18), color: BLACK, position: [-0.3, 1.165, 0.1] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.18), color: BLACK, position: [0.3, 1.165, 0.1] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.18), color: BLACK, position: [-0.3, 1.665, 0.1] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.18), color: BLACK, position: [0.3, 1.665, 0.1] },
      // small book blocks
      { geometry: new THREE.BoxGeometry(0.3, 0.2, 0.16), color: BOOK_BRICK, position: [-0.15, 1.32, 0.1] },
      { geometry: new THREE.BoxGeometry(0.2, 0.18, 0.16), color: BOOK_BLUE, position: [0.2, 1.31, 0.1] },
      { geometry: new THREE.BoxGeometry(0.25, 0.2, 0.16), color: BOOK_GREEN, position: [0.05, 1.82, 0.1] },
    ];
  },
  animations: [],
});
